import React from "react";
import DateHelper from "../../DateHelper/DateHelper";

class DateDataType extends React.Component{

  render() {
    if (this.props.data) {
      return <div className={this.renderAlignment()}>{DateHelper.printDateToScreen(this.props.data, this.props.date_format)}</div>
    } else {
      return (
        <em className="text-center">&nbsp;</em>
      );
    }
  }

  renderAlignment() {
    if (this.props.header && this.props.header.text_align === "left") {
      return "text-left";
    } else if (this.props.header && this.props.header.text_align === "center") {
      return "text-center";
    } else if (this.props.header && this.props.header.text_align === "right") {
      return "text-right";
    } else {
      ("");
    }
  }
};

export default DateDataType